<template>
<v-row class="eventsearch__row">
  <div class="eventsearch__wrapper">
    <v-row>
      <v-col cols="12">
        <div class="content__box">
          <v-row>
            <v-col cols="12">
              <div class="eventsearch__maintitle">
                <h1 class="content__box-title">
                  {{$t('search_event.find_events_at_reattendance')}}
                </h1>
                <p class="eventsearch__desc">{{$t('search_event.event_search__desc')}}</p>
                <p class="eventsearch__desc"><router-link :to="{ name: 'register' }" class="eventsearch__desc-link"> {{$t('register')}} </router-link> {{$t('search_event.for_free_to_get_started')}}!</p>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <!-- This Month’s Events -->
    <v-row v-if="hasEventsThisMonth">
      <v-col cols="12">
        <div class="eventsearch__card-box">
          <div class="eventsearch__card-header">
            <h5 class="eventsearch__card-title">{{$t('search_event.this_month_s_events')}}</h5>
            <span v-if="eventsThisMonthLoadMore" @click="loadMore('eventsThisMonth')" class="eventsearch__card-viewall">
              {{ $t('search_event.load_more') }}
              <v-icon large>
                mdi-arrow-right-bold-circle-outline
              </v-icon>
            </span>
          </div>
          <v-row>
            <v-col cols="12">
              <search-event-slider :events="eventsThisMonth" type="eventsThisMonth"></search-event-slider>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <!-- Next Month’s Events -->
    <v-row v-if="hasEventsNextMonth">
      <v-col cols="12">
        <div class="eventsearch__card-box">
            <div class="eventsearch__card-header">
              <h5 class="eventsearch__card-title">Next Month’s Events</h5>
              <span v-if="eventsNextMonthLoadMore" class="eventsearch__card-viewall" @click="loadMore('eventsNextMonth')">
                {{ $t('search_event.load_more') }}
                <v-icon large>
                  mdi-arrow-right-bold-circle-outline
                </v-icon>
              </span>
            </div>
            <v-row>
              <v-col cols="12">
                <search-event-slider :events="eventsNextMonth" type="eventsNextMonth"></search-event-slider>
              </v-col>
            </v-row>
        </div>
      </v-col>
    </v-row>

    <!-- Future Events -->
    <v-row v-if="hasFutureEvents">
      <v-col cols="12">
        <div class="eventsearch__card-box">
            <div class="eventsearch__card-header">
              <h5 class="eventsearch__card-title">Future Events</h5>
              <span v-if="futureEventsLoadMore" class="eventsearch__card-viewall" @click="loadMore('futureEvents')">
                {{ $t('search_event.load_more') }}
                <v-icon large>
                  mdi-arrow-right-bold-circle-outline
                </v-icon>
              </span>
            </div>
            <v-row>
              <v-col cols="12">
                <search-event-slider :events="futureEvents" type="futureEvents"></search-event-slider>
              </v-col>
            </v-row>
        </div>
      </v-col>
    </v-row>

    <!-- Replayed Events (On-Demand) -->
    <v-row v-if="hasReplayEvents">
      <v-col cols="12">
        <div class="eventsearch__card-box">
          <h5 class="eventsearch__card-title">{{ $t('search_event.replayed_events') }}</h5>
          <v-row>
            <v-col cols="12">
              <search-event-slider :events="completedEvents" type="completedEvents"></search-event-slider>
              <div class="text-end">
                <span v-if="completedEventsLoadMore" class="eventsearch__card-viewall" @click="loadMore('completedEvents')">
                  {{ $t('search_event.load_more') }}
                  <v-icon large>
                    mdi-arrow-right-bold-circle-outline
                  </v-icon>
                </span>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>
  </div>
  <div class="content__box" v-if="eventquicklookModal">
    <v-dialog
        v-model="eventquicklookModal"
        content-class=""
        @click:outside="eventquicklookModal = false"
        width="900"
      >
        <v-card class="eventsearch__modal">
          <div class="ra__form-heading">
            <v-card-title class="ra__modal-title">
              <h3 class="ra__modal-title--heading">{{ singleEvent.name }}</h3>
            </v-card-title>
            <div class="text-end">
              <v-btn icon class="pa-2" @click="eventquicklookModal = false">
                <v-icon class="icon-anim"> mdi-close </v-icon>
              </v-btn>
            </div>
          </div>
          <v-card-text>
            <div class="eventsearch__modal-body">
              <div class="eventsearch__modal-startend">
                <p><b>Starts:</b> {{ startDateTime(singleEvent.schedule.start_date_time) }}</p>
                <p><b>Ends:</b> {{ startDateTime(singleEvent.schedule.end_date_time) }}</p>
              </div>
              <div class="eventsearch__modal-imgbox">
                <RaMediaDisplay
                  location="primary"
                  :media="eventImage(singleEvent.attachments)"
                  :sizes="sizes"
                />
              </div>
              <div class="eventsearch__modal-desc">
                <p v-html="singleEvent.description"></p>
              </div>
              <div class="eventsearch__modal-action">
                <v-btn
                  large
                  outlined
                  class="btn-primary"
                  :to="{ name: 'public-event-page', params: { eventId: singleEvent.id } }"
                >
                  {{ $t('search_event.event_details') }}
                </v-btn>
              </div>
            </div>
            </v-card-text>
        </v-card>
    </v-dialog>
  </div>
</v-row>
</template>
<script>
import axios from 'axios';
import mediaHandler from '~/plugins/media/mediaHandler'
import RaMediaDisplay from '~/components/media/RaMediaDisplay'
import { getDateOnly, getTimeOnly} from '~/plugins/dateTimeHelper'
import size from 'lodash/size'
import SearchEventSlider from './searchEventSlider.vue';
export default {
  layout: 'default',
  components: { RaMediaDisplay, SearchEventSlider },
  metaInfo() {
    return {
      title: this.$t("search_event.search_event"),
    };
  },
  data(){
    return {
      sizes: '100vw',
      eventsThisMonth: [],
      eventsNextMonth: [],
      futureEvents: [],
      completedEvents: [],
      eventsThisMonthCurrentPage: 1,
      eventsNextMonthCurrentPage: 1,
      futureEventsCurrentPage: 1,
      completedEventsCurrentPage: 1,
      eventsThisMonthLoadMore: true,
      eventsNextMonthLoadMore: true,
      futureEventsLoadMore: true,
      completedEventsLoadMore: true,
      eventquicklookModal: false,
      singleEvent: {}
    }
  },
  computed: {
    hasEventsThisMonth(){
      return size(this.eventsThisMonth) > 0
    },
    hasEventsNextMonth(){
      return size(this.eventsNextMonth) > 0
    },
    hasFutureEvents(){
      return size(this.futureEvents) > 0
    },
    hasReplayEvents(){
      return size(this.completedEvents) > 0
    },

  },
  async created () {
    await this.showLoader(true)
    await this.getAllEvents();
    await this.showLoader(false)
    this.$root.$on('open-event-modal', (payload) => {
      this.singleEvent = payload
      this.eventquicklookModal = true
    })
  },
  methods: {
    async getAllEvents(){
      await axios
      .get('/search-event')
      .then(response => {
        this.eventsThisMonth = response.data.eventsThisMonth
        this.eventsNextMonth = response.data.eventsNextMonth
        this.futureEvents = response.data.futureEvents
        this.completedEvents = response.data.completedEvents
      })
      .catch((error) => {
        console.log(error);
      })
    },
    eventImage(attachment) {
      return mediaHandler.getAllMediaForModel('Event', attachment)
    },
    startDate (dateTime) {
      return getDateOnly(dateTime)
    },
    startTime (dateTime) {
      return getTimeOnly(dateTime)
    },
    startDateTime(dateTime){
      return `${this.startDate(dateTime)}, ${this.startTime(dateTime)}`
    },
    async loadMore(type){
      const loadMore = `${type}LoadMore`;
      const page = ++this[`${type}CurrentPage`];
      await this.showLoader(true)
      const res = await this.loadMoreData(page, loadMore);
      await this.showLoader(false)
      const events = res.data && res.data[type];
      if(events && events.length){
        this[type].push(...events)
        this.$emit('update-carousel-key', type)
      }
      else{
        this[`${type}LoadMore`] = false
      }
    },
    async loadMoreData(page, type){
      return await axios
        .get('/search-event', {params: {[type] : page}})
        .then((response) => {
          return response
        })
        .catch((error) => (console.log(error)))
    },
  },
}
</script>
